import React from "react";
import AboutProductImage from "./about-product-image/about-product-image";
import aboutImage from "../../assets/images/about.png";
import { ReactComponent as LogoIcon } from '../../assets/icons/logo-icon.svg';
import s from "./about-product.module.scss"

const AboutProduct = (props) => {
    return (
        <div className={s.AboutProduct}>
            <div className={s.AboutContent}>
                <div className={s.textBlock}>
                    <h1>{props.getValue('ABOUT_PRODUCT')}</h1>
                    <div className={s.quotesBlock}>
                        <div className={s.LogoIcon}><LogoIcon /></div>
                        {props.selectedLanguage !== 'KAZ' 
                        ? <span><b>{props.getValue('BE_FIRST_TO_KNOW')}</b>{props.getValue('WHO_WROTE_ABOUT')}</span>
                        : <span>{props.getValue('WHO_WROTE_ABOUT')}<b>{props.getValue('BE_FIRST_TO_KNOW')}</b></span>}
                    </div>
                    <div className={s.quotesBlock}>
                        <div className={s.LogoIcon}><LogoIcon /></div>
                        {props.selectedLanguage !== 'KAZ' 
                        ? <span><b>{props.getValue('MONITOR_THE_REPUTATION')}</b>{props.getValue('COMPANIES_BRANDS_TOP_MANAGMENT')}{props.getValue('MEDIA_SOCIAL_TELEGRAM')}</span>
                        : <span>{props.getValue('COMPANIES_BRANDS_TOP_MANAGMENT')}<b>{props.getValue('MONITOR_THE_REPUTATION')}</b>{props.getValue('MEDIA_SOCIAL_TELEGRAM')}</span>}
                    </div>
                    <div className={s.quotesBlock}>
                        <div className={s.LogoIcon}><LogoIcon /></div>
                        <span>{props.getValue('GET_VALUABLE_INSIGHTS_BOLD')}<b>{props.getValue('GET_VALUABLE_INSIGHTS')}</b>{props.getValue('IN_REALTIME')}</span>
                    </div>
                </div>
                <div className={s.imageBlock}>
                    <AboutProductImage getValue={props.getValue}/>
                    
                </div>
            </div>
        </div>
    )
}

export default AboutProduct;